import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class AccountingProfileService {
  constructor(private http: HttpClient) {

  }

  transformAccountingProfileData(data) {
    let formatedData = [];
    data.accountingprofile.forEach(function(item:any){
      let itemData:any = {};
      itemData.accounting_profile_id = item.id;
      itemData.accounting_profile_name = item.name;
      itemData.priority = item.priority;
      itemData.accounting_profile_status = item.status;
      itemData.manage_session = item.managesession;
      itemData.mapping_master_id = item.mappingmasterid;
      itemData.enable_cdr = item.enablecdr;
      itemData.check_item = item.checkitem;
      itemData.updatedate = item.updatedate;
      formatedData.push(itemData);
    });
    return {content:formatedData, pageDetails: data.pageDetails ? data.pageDetails : null };
  }

  getAccountingProfileDataWithPageing(params: HttpParams): Observable<any> {
    const post_url = BASE_API_URL + 'accountingprofile/list';

    return this.http.post<any>(post_url,params,
      { headers: httpOptions.headers, }).pipe(
        map((res: any) => {
          return this.transformAccountingProfileData(res);
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  getAccountingProfile(accountingProfile_id) : Observable<any> {
    const get_url = BASE_API_URL + 'accountingprofile/' + accountingProfile_id;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  insertAccountingProfile(accounting_profile_data: any): Observable<any> {
    const post_url = BASE_API_URL + 'accountingprofile';
    return this.http.post<any>(post_url, accounting_profile_data, httpOptions).pipe(
      map(data => data),
      catchError((error: any) => {
        return throwError(error);
      })
    );

  }

  updateAccountingProfile(accounting_profile_data: any,accounting_profile_id:any): Observable<any> {
    const update_url = BASE_API_URL +"accountingprofile/"+ accounting_profile_id;
    return this.http.put<any>(update_url, accounting_profile_data, httpOptions).pipe(
      map(data => data),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  deleteAccountingProfile(accounting_profile_id: any): Observable<any> {
    const delete_url = BASE_API_URL+"accountingprofile/" + accounting_profile_id;
    return this.http.delete(delete_url, httpOptions);
  }

}
